import axios from 'axios';
import { safeStorage } from './lib/safeStorage';

const configuredBackend = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
const backend = /(^|\.)fbd-cleaning\.com$/i.test(window.location.hostname) ? '' : configuredBackend.replace(/^http:\/\//i, window.location.protocol === 'https:' ? 'https://' : 'http://');
const BASE = `${backend}/api/b2c`;

const api = axios.create({ baseURL: BASE, timeout: 30000 });

const TOKEN_KEY = 'fbd_token';

export const getToken = () => safeStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? safeStorage.setItem(TOKEN_KEY, t) : safeStorage.removeItem(TOKEN_KEY));
export const staffPortal = () => `${(process.env.REACT_APP_STAFF_PORTAL_URL || '').replace(/\/$/, '')}/staff`;

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => `${(item.loc || []).slice(1).join('.')}: ${item.msg}`).join(' ');
  if (error?.response?.status === 401) return 'Your session expired. Please sign in again.';
  if (!error?.response) return 'Could not reach the server. Your changes have not been saved. Please retry.';
  return error?.message || 'Could not save. Please try again.';
}

// attach token on each request
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// resolve media/image urls (backend-relative /api/uploads -> absolute)
export const resolveUrl = (url) => {
  if (!url) return url;
  if (url.startsWith('/api/uploads/')) return `${backend}${url.replace('/api/uploads/', '/api/b2c/uploads/')}`;
  if (url.startsWith('/api/')) return `${backend}${url}`;
  return url;
};

export const API = {
  // products
  getProducts: () => api.get('/products').then((r) => r.data),
  updateProduct: (id, patch) => api.put(`/products/${id}`, patch).then((r) => r.data),
  // settings
  getSettings: () => api.get('/settings').then((r) => r.data),
  updateSettings: (s) => api.put('/settings', s).then((r) => r.data),
  // reviews
  getReviews: () => api.get('/reviews').then((r) => r.data),
  addReview: (rev) => api.post('/reviews', rev).then((r) => r.data),
  deleteReview: (id) => api.delete(`/reviews/${id}`).then((r) => r.data),
  // orders
  getOrders: () => api.get('/orders').then((r) => r.data),
  createOrder: (order) => api.post('/orders', order).then((r) => r.data),
  updateOrderStatus: (id, status) => api.put(`/orders/${id}/status`, { status }).then((r) => r.data),
  // combos
  getCombos: () => api.get('/combos').then((r) => r.data),
  createCombo: (c) => api.post('/combos', c).then((r) => r.data),
  updateCombo: (id, c) => api.put(`/combos/${id}`, c).then((r) => r.data),
  deleteCombo: (id) => api.delete(`/combos/${id}`).then((r) => r.data),
  // auth
  staffSession: () => api.get('/staff/me').then((r) => r.data),
  // upload
  upload: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
};

export default api;
